import { updateEverExpanded } from './index';
import serverApi from '../services/serverApi';

export const firstExpand = () => {
  return async function(dispatch, getState) {
    if (!getState().everExpanded) {
      dispatch(updateEverExpanded(true));
      await serverApi.reportFirstExpand(getState().allowInput);
    }
  };
};
